import { AxiosResponse } from 'axios'
import magentoAxios from '../../api/global/magentoAxios'

import { env } from '@js/utils/env'
import gql from '@js/api/utils/gql'
import getStoreName from '@js/api/utils/getStoreName'

interface CreateCustomerPayload {
  firstName: string
  middleName?: string
  lastName: string
  personalMobilePhone: string
  email: string
  password: string
  secondaryEmail?: string
  recaptchaToken?: string
}

interface CreateCustomerResponse {
  data: {
    createCustomerV2: {
      customer: {
        firstname: string
        lastname: string
        email: string
      } | null
    }
  }
  errors?: [{ message: string }]
}

/**
 * Password confirmation and email confirmation are required in the form,
 * but Magento doesn't have fields for those values, so they must be
 * validated on the frontend.
 */
export const createCustomerMutation = gql`
  mutation(
    $firstName: String!
    $middleName: String
    $lastName: String!
    $email: String!
    $password: String!
    $secondaryEmail: String
    $customerContactNumber: String!
  ) {
    wceiCreateCustomer(
      input: {
        first_name: $firstName
        middle_name: $middleName
        last_name: $lastName
        email: $email
        password: $password
        secondary_email: $secondaryEmail
        customer_contact_number: $customerContactNumber
      }
    ) {
      customer {
        first_name
        last_name
        email
        customer_contact_number
      }
    }
  }
`

/**
 * @throws {string}
 *
 * Will throw one error message; Magento only returns one at a time, rather than an array of all errors.
 */
export const createCustomer = async (payload: CreateCustomerPayload): Promise<void> => {
  const { data }: AxiosResponse<CreateCustomerResponse> = await magentoAxios({
    method: 'POST',
    url: env.magento.GRAPHQL_URL,
    recaptchaToken: payload.recaptchaToken,
    headers: {
      'Content-Type': 'application/json',
      Store: getStoreName()
    },
    data: {
      query: createCustomerMutation,
      variables: {
        firstName: payload.firstName,
        middleName: payload.middleName,
        lastName: payload.lastName,
        customerContactNumber: payload.personalMobilePhone,
        email: payload.email,
        password: payload.password,
        secondaryEmail: payload.secondaryEmail,
      },
    },
  } as any)

  if (data.errors) {
    throw data.errors[0].message
  }
}
